module["exports"] = [
  "Sverige"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/default_country.js
// module id = 1589
// module chunks = 0